import {
  CREATE_SOCIAL_LINK,
  CREATE_SOCIAL_LINK_FAILURE,
  CREATE_SOCIAL_LINK_SUCCESS,
  DELETE_SOCIAL_LINK,
  DELETE_SOCIAL_LINK_FAILURE,
  DELETE_SOCIAL_LINK_SUCCESS,
  GET_SOCIAL_LINK,
  GET_SOCIAL_LINKS,
  GET_SOCIAL_LINKS_FAILURE,
  GET_SOCIAL_LINKS_SUCCESS,
  GET_SOCIAL_LINK_FAILURE,
  GET_SOCIAL_LINK_SUCCESS,
  UPDATE_SOCIAL_LINK,
  UPDATE_SOCIAL_LINK_FAILURE,
  UPDATE_SOCIAL_LINK_SUCCESS,
} from "./actionTypes";

const initialState = {
  socialLinks: [],
  socialLink: {},
  isLoggedIn: null,
  loading: false,
  error: "",
};

const socialLinks = (state = initialState, action) => {
  switch (action.type) {
    case GET_SOCIAL_LINKS:
      return {
        ...state,
        loading: true,
      };

    case GET_SOCIAL_LINKS_SUCCESS:
      return {
        ...state,
        socialLinks: action.payload,
        loading: false,
      };

    case GET_SOCIAL_LINKS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // ===================================================
    // ===================================================

    case GET_SOCIAL_LINK:
      return {
        ...state,
        loading: true,
      };

    case GET_SOCIAL_LINK_SUCCESS:
      return {
        ...state,
        socialLink: action.payload,
        loading: false,
      };

    case GET_SOCIAL_LINK_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };



    // ===================================================
    // ===================================================

    case CREATE_SOCIAL_LINK:
      return {
        ...state,
        loading: true,
      };

    case CREATE_SOCIAL_LINK_SUCCESS:
      return {
        ...state,
        socialLinks: [...state.socialLinks, action.payload],
        loading: false,
      };

    case CREATE_SOCIAL_LINK_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // ===================================================
    // ===================================================

    case UPDATE_SOCIAL_LINK:
      return {
        ...state,
        loading: true,
      };

    case UPDATE_SOCIAL_LINK_SUCCESS:
      return {
        ...state,
        socialLinks: state.socialLinks.map((socialLink) =>
          socialLink._id === action.payload._id ? action.payload : socialLink
        ),
        loading: false,
      };

    case UPDATE_SOCIAL_LINK_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // ===================================================
    // ===================================================

    case DELETE_SOCIAL_LINK:
      return {
        ...state,
        loading: true,
      };

    case DELETE_SOCIAL_LINK_SUCCESS:
      return {
        ...state,
        socialLinks: state.socialLinks.filter(
          (socialLink) => socialLink._id !== action.payload?.id
        ),
        loading: false,
      };

    case DELETE_SOCIAL_LINK_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // ===================================================
    // ===================================================

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default socialLinks;
